module.exports = __webpack_public_path__ + "img/dotes_8x4.531b1e01.svg";